<template>
  <div>
    <form id="frm-dictum"
          ref="frm-dictum"
          accept-charset="UTF-8"
          class="card"
          method="GET"
          onsubmit="return false">
      
      <div class="card-header">
        <h1 class="card-title mb-0">Dictamen de protocolo</h1>
      </div>
      <div class="card-body">
        <p class="mb-4">Ingrese los datos solicitados para poder aplicar el dictamen.</p>
        <div class="form-group">
          <label class="d-block font-weight-normal"
                 for="dictum_type_key">Tipo de dictamen:
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <select id="dictum_type_key"
                  v-model="dictum_type_key"
                  class="custom-select"
                  name="dictum_type_key">
            <option disabled
                    value="">
              Seleccione el tipo de dictamen
            </option>
            <option v-for="option in dictumTypes"
                    :key="option.key"
                    :value="option.key">
              {{ option.title }}
            </option>
          </select>
        </div>
        <div class="form-group" v-if="committee && committee.key === 'etica'">
          <label class="d-block font-weight-normal"
                 for="risk">Riesgos de dictamen:
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <select id="risk"
                  v-model="risk"
                  class="custom-select"
                  name="risk">
            <option v-for="option in riskOptions"
                    :key="option.value"
                    v-bind:value="option.value">
              {{ option.text }}
            </option>
          </select>
        </div>
        <div v-if="(dictum_type_key === 'aprobado_etapas') && committee.key === 'investigacion'"
             class="form-group">
          <label class="d-block font-weight-normal">
            Seleccione si el comité requiere cambios en el protocolo.
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <div class="custom-control custom-control-inline custom-radio">
            <input id="requireChangesTrue"
                   v-model="require_changes"
                   :value="1"
                   class="custom-control-input"
                   name="require_changes"
                   type="radio">
            <label class="custom-control-label"
                   for="requireChangesTrue">Sí</label>
          </div>
          <div class="custom-control custom-control-inline custom-radio">
            <input id="requireChangesFalse"
                   v-model="require_changes"
                   :value="0"
                   class="custom-control-input"
                   name="require_changes"
                   type="radio">
            <label class="custom-control-label"
                   for="requireChangesFalse">No</label>
          </div>
        </div>
        <div v-if="(dictum_type_key === 'aprobado' || dictum_type_key === 'aprobado_etapas') && committee.key === 'etica'"
             class="form-group">
          <label class="d-block font-weight-normal">
            ¿El protocolo requiere renovación anual?
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <div class="custom-control custom-control-inline custom-radio">
            <input id="requireRenewalTrue"
                   v-model="require_renewal"
                   :value="1"
                   class="custom-control-input"
                   name="require_renewal"
                   type="radio">
            <label class="custom-control-label"
                   for="requireRenewalTrue">Sí</label>
          </div>
          <div class="custom-control custom-control-inline custom-radio">
            <input id="requireRenewalFalse"
                   v-model="require_renewal"
                   :value="0"
                   class="custom-control-input"
                   name="require_renewal"
                   type="radio">
            <label class="custom-control-label"
                   for="requireRenewalFalse">No</label>
          </div>
        </div>
        <file-input input-id="file"
                    input-name="file"
                    ref="fileInput"
                    input-place-holder="Archivo de dictamen"
                    label-text="Archivo:"
                    :required="true"></file-input>
        <div class="form-group">
          <label class="d-block font-weight-normal"
                 for="comments">Comentarios:
            <abbr style="text-decoration: none;"
                  title="Campo obligatorio">*</abbr>
          </label>
          <textarea id="comments"
                    v-model="comments"
                    class="form-control"
                    name="comments"
                    placeholder="Ingrese sus comentarios..."
                    rows="3"></textarea>
        </div>
      </div>
      <div class="card-footer d-flex py-2 px-2">
        <button class="btn btn-lg btn-primary mr-2"
                type="submit">Registrar dictamen
        </button>
      </div>
    </form>
    
    <portal to="modals">
      <ok-cancel-dialog id="accept-dictum-modal"
                        ref="accept-dictum-modal"
                        content="<p>¿Esta seguro de guardar este dictamen?</p>"
                        ok-button-text="Confirmar"
                        title="Guardar dictamen"
                        @ok-button-pressed="saveDictum"></ok-cancel-dialog>
    </portal>
  </div>
</template>

<script>
  import 'jquery-validation'
  import OkCancelDialog from '../../ui/OkCancelDialog'
  import { mapActions, mapGetters } from 'vuex'
  import autosize from 'autosize'
  import FileInput from '../../ui/FileInput.vue'
  
  export default {
    name: 'DictumProtocol',
    components: {
      OkCancelDialog,
      FileInput,
    },
    data() {
      return {
        dictum_type_key: '',
        risk: '',
        require_renewal: null,
        require_changes: null,
        riskOptions: [
          {
            text: 'Seleccione un riesgo',
            value: '',
          },
          {
            text: 'Sin riesgo',
            value: 'sin_riesgo',
          },
          {
            text: 'Riesgo mínimo',
            value: 'minimo',
          },
          {
            text: 'Riesgo mayor al mínimo',
            value: 'mayor_minimo',
          },
        ],
        comments: '',
      }
    },
    props: {
      protocol: Object,
      committee: Object,
      task: Object,
    },
    computed: {
      ...mapGetters({
        dictumTypes: 'committees/dictumTypes',
      }),
    },
    methods: {
      ...mapActions({
        getDictumTypes: 'committees/getDictumTypes',
      }),
      
      async saveDictum() {
        this.$refs['accept-dictum-modal'].sending = true
        
        const file = this.$refs.fileInput.$refs.file.files[0] 

        const formData = new FormData()
        
        formData.append('protocol_id', this.protocol.id)
        formData.append('committee_id', this.committee.id)
        formData.append('task_id', this.task.id)
        formData.append('dictum_type_key', this.dictum_type_key)
        formData.append('risk', this.risk)
        formData.append('file', file)
        formData.append('comments', this.comments)
        
        if(this.dictum_type_key === 'aprobado' || this.dictum_type_key === 'aprobado_etapas') {
          formData.append('require_renewal', this.require_renewal)
        }
        
        if(this.dictum_type_key === 'aprobado_etapas' && this.committee.key === 'investigacion') {
          formData.append('require_changes', this.require_changes)
        }
        
        this.$emit('register-dictum', formData, () => {
          this.$refs['accept-dictum-modal'].sending = false
          this.$refs['accept-dictum-modal'].close()
        })
      },
      
      async load() {
        const { protocol, committee } = this
        
        await this.getDictumTypes({
          protocol,
          committee,
        })
      },
    },
    async mounted() {
      autosize(document.getElementsByTagName('textarea'))
      
      const vm = this
      
      $('#frm-dictum').validate({
        highlight: function(element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function(element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function(label, element) {
          if (element.hasClass('select2-input')) {
            label.insertAfter(element.siblings('span.select2'))
          }
          else if (element.is(':radio') || element.is(':checkbox')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
  
          label.addClass('invalid-feedback')
        },
        rules: {
          dictum_type_key: {
            required: true,
          },
          risk: {
            required: true,
          },
          comments: {
            required: true,
          },
          file: {
            required: true,
          },
          require_changes: {
            required: function () {
              return vm.dictum_type_key === 'aprobado_etapas'
            }
          }
        },
        messages: {
          dictum_type_key: {
            required: 'Este campo es requerido.',
          },
          risk: {
            required: 'Este campo es requerido.',
          },
          comments: {
            required: 'Este campo es requerido.',
          },
          file: {
            required: 'Este campo es requerido.',
          },
          require_changes: {
            required: 'Seleccione una opción',
          },
        },
        submitHandler(form) {
          $('#accept-dictum-modal').modal('show')
        },
      })
      
      await this.load()
    },
  }
</script>
